// extracted by mini-css-extract-plugin
export const intro = "vendors-intro-module--intro--smMV6";